class CoaDeliveryTimeline extends HTMLElement {
  connectedCallback() {
    this.refreshDates();
    this.refreshOnVisibility = () => {
      if (!document.hidden) this.refreshDates();
    };
    document.addEventListener('visibilitychange', this.refreshOnVisibility);
    this.refreshInterval = setInterval(() => this.refreshDates(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.refreshInterval);
    document.removeEventListener('visibilitychange', this.refreshOnVisibility);
  }

  refreshDates(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en', {
      timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now);
    const value = type => Number(parts.find(part => part.type === type).value);
    const today = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    const locale = this.lang || document.documentElement.lang || 'fr';
    const format = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', timeZone: 'UTC' });
    this.querySelectorAll('[data-coa-date-offset]').forEach(element => {
      const date = new Date(today);
      date.setUTCDate(date.getUTCDate() + Number(element.dataset.coaDateOffset));
      element.dateTime = date.toISOString().slice(0, 10);
      element.textContent = format.format(date);
    });
    this.querySelectorAll('[data-coa-dates]').forEach(element => { element.hidden = false; });
    this.querySelectorAll('[data-coa-relative]').forEach(element => { element.hidden = true; });
  }
}

if (!customElements.get('coa-delivery-timeline')) {
  customElements.define('coa-delivery-timeline', CoaDeliveryTimeline);
}
